import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from '../env.service';
import { SafeHtml } from '@angular/platform-browser';
import { ThemeSettingService } from '../services/theme-setting.service';
import { ThemeSetting } from '../objects/ThemeObject';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ContactUsComponent implements OnInit {

  serviceUrl: string;
  contactUs: SafeHtml;
  isBusy: boolean = false;
  loaderConfig: any;

  constructor(private themeSettingService: ThemeSettingService, private http:HttpClient, private env: EnvService) {
    this.serviceUrl = this.env.servicePath
   }

  ngOnInit() {
    let themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
    this.isBusy = true;
    this.http.get("assets/contact-us/contact-us.html", { responseType: "text" }).subscribe(result => {
      this.contactUs = result;
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
    })
  }

}
